import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrlHelper, UrlQueryParams } from '../api-url-helper';
import { HttpHeaders } from '@angular/common/http';
import { HttpClientHelper } from '../http-helper';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { StorageService } from 'app/storageprovider';

@Injectable()
export class PaymentService {
    region = this._storage.GetConfig()['region'];
    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper,
        private _storage: StorageService,
    ) { }

    createOrder(user, productID,promotionsCode ="", activityKey = ''): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        const body = new UrlQueryParams();

        body.set('ProductId', productID);
        body.set('OrderID', '');
        body.set('SysName', 'creditcard');
        body.set('AccountName', user.name);
        body.set('ToUID', user.id);
        body.set('promotions', promotionsCode);
        body.set('activityKey', activityKey);

        var apiURL = this._apiUrlHelper.urlBuilder('payment-create-order', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
            region: this.region,
        });

        // if(!environment.production)
        // {
        //     apiURL = apiURL.replace("https://m6.ifvod.tv","http://localhost:11111/");
        // }
        return this._httpClientHelper
            .post(apiURL, body.toString(), httpOptions)
            .pipe(map(r => {
                return r[0];
            }));
    }

    getOrder(user): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };

        const body = new UrlQueryParams();

        const apiURL = this._apiUrlHelper.urlBuilder('payment-get-order', {
            // uid: user.id,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
            region: this.region,
        });

        return this._httpClientHelper
            .post(apiURL, body.toString(), httpOptions)
            .pipe(map(l => {
                const items = JSON.parse(JSON.stringify(l));
            }));
    }

    getAddress(user, addressId): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        const body = new UrlQueryParams();

        body.set('AddressID', addressId);

        const apiURL = this._apiUrlHelper.urlBuilder('payment-get-address', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });

        return this._httpClientHelper
            .post(apiURL, body.toString(), httpOptions)
            .pipe(map(res => {
                return res[0];
            }));
    }

    removeAddress(user, addressId): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        const body = new UrlQueryParams();

        body.set('AddressID', addressId);

        const apiURL = this._apiUrlHelper.urlBuilder('payment-remove-address', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });

        return this._httpClientHelper
            .post(apiURL, body.toString(), httpOptions)
            .pipe(map(res => {
                return res;
            }));
    }

    postAddress(user, address, addressId): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        const body = new UrlQueryParams();

        body.set('Country', address.country);
        body.set('Lastname', address.lastName);
        body.set('Firstname', address.firstName);
        body.set('City', address.city);
        body.set('Address', address.address);
        body.set('ZipCode', address.zip);
        body.set('Phone', address.mobile);
        body.set('Email', address.email);
        if (addressId) {
            body.set('ID', addressId);
        }

        const apiURL = this._apiUrlHelper.urlBuilder('payment-add-address', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });

        return this._httpClientHelper
            .post(apiURL, body.toString(), httpOptions)
            .pipe(map(res => {
                return res;
            }));
    }

    getOrderInfo(creditcard_addressid) {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
  
        var apiURL = this._apiUrlHelper.urlBuilder('payment-get-orderinfo', {
            region: this.region,
        });
      
        return this._httpClientHelper
        .post(apiURL, ApiUrlHelper.toQueryString(creditcard_addressid), httpOptions)
        .pipe(map(res => {
            return res;
        }));



    }

    payOrder(user,creditcard_addressid) {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
  
        var apiURL = this._apiUrlHelper.urlBuilder('payment-pay-order', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
            region: this.region,
        });
        // if(!environment.production)
        // {
        //     apiURL = apiURL.replace("https://m6.ifvod.tv","http://localhost:11111/");
        // }
        return this._httpClientHelper
        .post(apiURL, ApiUrlHelper.toQueryString(creditcard_addressid), httpOptions)
        .pipe(map(res => {
            return res;
        }));



    }
    public generateThirdParty(user,viewModel)
    {
        const api = this._apiUrlHelper.urlBuilder("payment-generate-thirparty",{
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
            region: this.region,
        });
        return this._httpClientHelper.post(api,viewModel,null);
    }

    /*
    ** 生成一张扫码支付的订单
    */
   public generateOrder(user,viewModel)
   {
       
        var apiURL = this._apiUrlHelper.urlBuilder('payment-generate-order', {
            uid: user.id,
            gid: user.token.gid,
            expire: user.token.expire,
            sign: user.token.sign,
            token: user.token.token,
            region: this.region,
        });
        if(!environment.production)
        {
            apiURL= apiURL.replace("https://activity.ifvod.tv","http://localhost:11111");
        }

       return this._httpClientHelper.post(apiURL, viewModel,null);
   }
   /*
   ** 生成一张扫码支付的订单
   */
    public queryOrder(user,viewModel)
    {
        var apiURL = this._apiUrlHelper.urlBuilder('payment-query-order', {
            uid: user.id,
            gid: user.token.gid,
            expire: user.token.expire,
            sign: user.token.sign,
            token: user.token.token,
            region: this.region,
        });
        if(!environment.production)
        {
            apiURL= apiURL.replace("https://m10.ifvod.tv","http://localhost:11111");
        }
        return this._httpClientHelper.post(apiURL, viewModel,null);
    }


}